import {PATTERN_SWITCH} from 'session/constants.js';
import Resolution from 'engine/Resolution.js';
import PatternSwitchEvent from 'session/PatternSwitchEvent.js';
import TrackVolumeChangeEvent from 'session/TrackVolumeChangeEvent.js';
import {TRACK_VOLUME_CHANGE} from 'session/constants.js';
import GroupVolumeChangeEvent from 'session/GroupVolumeChangeEvent.js';
import {GROUP_VOLUME_CHANGE} from 'session/constants.js';
import TrackMuteEvent from 'session/TrackMuteEvent.js';
import {TRACK_MUTE} from 'session/constants.js';
import GroupMuteEvent from 'session/GroupMuteEvent.js';
import {GROUP_MUTE} from 'session/constants.js';
import ParameterChangeEvent from 'session/ParameterChangeEvent.js';
import {PARAMETER_CHANGE} from 'session/constants.js';
import TrackSendVolumeChangeEvent from 'session/TrackSendVolumeChangeEvent.js';
import {TRACK_SEND_VOLUME_CHANGE} from 'session/constants.js';
import TrackSoloEvent from 'session/TrackSoloEvent.js';
import {TRACK_SOLO} from 'session/constants.js';
import TrackReverseEvent from 'session/TrackReverseEvent.js';
import {TRACK_REVERSE,
        SEQUENCE_ROLL,
        RESOLUTION_CHANGE,
        SUB_SEQUENCE_VOLUME_CHANGE,
       } from 'session/constants.js';
import SequenceRollEvent from 'session/SequenceRollEvent.js';
import ResolutionChangeEvent from 'session/ResolutionChangeEvent.js';
import SubSequenceVolumeChangeEvent from 'session/SubSequenceVolumeChangeEvent.js';

export function loadEventFromJson(json, type, sequencerEngine, subSequence) {
    let event = undefined;
    switch (type) {
    case PATTERN_SWITCH:
        event = new PatternSwitchEvent();
        break;
    case TRACK_VOLUME_CHANGE:
        event = new TrackVolumeChangeEvent();
        break;
    case GROUP_VOLUME_CHANGE:
        event = new GroupVolumeChangeEvent();
        break;
    case TRACK_MUTE:
        event = new TrackMuteEvent();
        break;
    case TRACK_SOLO:
        event = new TrackSoloEvent();
        break;
    case GROUP_MUTE:
        event = new GroupMuteEvent();
        break;
    case PARAMETER_CHANGE:
        event = new ParameterChangeEvent();
        break;
    case TRACK_SEND_VOLUME_CHANGE:
        event = new TrackSendVolumeChangeEvent();
        break;
    case TRACK_REVERSE:
        event = new TrackReverseEvent();
        break;
    case RESOLUTION_CHANGE:
        event = new ResolutionChangeEvent();
        break;
    case SEQUENCE_ROLL:
        event = new SequenceRollEvent(false, new Resolution());
        break;
    case SUB_SEQUENCE_VOLUME_CHANGE:
        event = new SubSequenceVolumeChangeEvent();
        break;
    }
    
    if (event !== undefined) {
        event.fromJson(json, sequencerEngine);
        if (event !== undefined) {
            event.subSequence = subSequence;
        }
    }

    return event;
}
